import { EnvConstant } from '../configs/env.configs';

const { CC_API_BASE_URL } = EnvConstant;

/**
 * Authentication & Registration URLs
 *
 */
export const SIGN_UP = `${CC_API_BASE_URL}/users/sign-up`;
export const LOGIN = `${CC_API_BASE_URL}/users/login`;
export const GET_AUTHENTICATED_USER = `${CC_API_BASE_URL}/users/me`;
export const SAVE_ADDRESS = `${CC_API_BASE_URL}/users/address`;
export const UPDATE_USER_MFA_PREFERENCES = `${CC_API_BASE_URL}/users/mfa-preferences`;
export const MFA_CHALLENGE = `${CC_API_BASE_URL}/users/login/respond-challenge`;
export const FORGOT_PASSWORD = `${CC_API_BASE_URL}/users/forgot-password`;
export const RESET_PASSWORD = `${CC_API_BASE_URL}/users/reset-password`;
export const EMAIL_CHANGE = `${CC_API_BASE_URL}/users/settings/email`;
export const EMAIL_CONFIRM = `${EMAIL_CHANGE}/confirm-update`;
export const UPDATE_PHONE_NUMBER = `${CC_API_BASE_URL}/users/settings/phone-number`;

/**
 * Account Details
 */

export namespace AccountUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/accounts`;

  export const CREATE = `${BASE_URL}`;
  export const RETRIEVE = `${BASE_URL}/{id}`;
  export const PATCH = `${BASE_URL}/{id}`;
  export const PATCH_JOINT_INTEREST = `${BASE_URL}/{id}/joint-interest`;
  export const PATCH_BENEFICIARIES = `${BASE_URL}/{id}/beneficiaries`;
  export const UPDATE_SUITABILITY_INFORMATION = `${BASE_URL}/{id}/suitability-information`;
  export const UPDATE_FINANCIAL_ASSETS = `${BASE_URL}/{id}/financial-assets`;
  export const SUBMIT = `${BASE_URL}/{id}/submit`;
  export const SWITCH = `${BASE_URL}/{id}/switch`;
  export const LINK = `${BASE_URL}/{id}/link`;
  export const DOWNLOAD_AGREEMENT = `${BASE_URL}/{id}/agreement`;
  export const DOWNLOAD_SIGNATURE = `${BASE_URL}/{id}/signatures`;
  export const UPDATE_SIGNATURE = `${BASE_URL}/{id}/signatures`;
  export const SYNC_STATUS_LIST = `${BASE_URL}/sync-status`;
}

export namespace AccountHolderUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/accounts/{id}/account-holders/{accountHolderId}`;
  const ACCOUNT_BASE_URL = `${CC_API_BASE_URL}/accounts/{id}`;

  export const PATCH = `${BASE_URL}`;
  export const PHYSICAL_ADDRESS = `${BASE_URL}/physical-address`;
  export const MAILING_ADDRESS = `${BASE_URL}/mailing-address`;
  export const TRUSTED_CONTACT = `${ACCOUNT_BASE_URL}/trusted-contact`;
  export const FINANCIAL_EMPLOYMENT = `${BASE_URL}/financial-employment`;
  export const DISCLOSURE = `${BASE_URL}/disclosure`;

  export const LIST_UPDATE_REQUESTS = `${BASE_URL}/update-requests`;
  export const APPROVE_UPDATE_REQUEST = `${BASE_URL}/update-requests/{requestId}/approve`;
  export const REJECT_UPDDATE_REQUEST = `${BASE_URL}/update-requests/{requestId}/reject`;
}

export namespace AccountBalanceUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/balances`;

  export const RETRIEVE = `${BASE_URL}/{accountId}`;
  export const LIST = `${BASE_URL}`;
  export const RETRIEVE_WITHDRAWAL_FUNDS = `${BASE_URL}/{accountId}/withdrawal-funds`;
}

export namespace AccountApplicationUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/applications/{id}/accounts/{accountId}`;

  export const RETRIEVE = `${BASE_URL}`;
  export const UPDATE = `${BASE_URL}`;
  export const UPLOAD_DOCUMENT = `${BASE_URL}/documents`;
  export const DOWNLOAD_DOCUMENT = `${BASE_URL}/documents/{documentId}`;
  export const UPDATE_DOCUMENT = `${BASE_URL}/documents/{documentId}`;
  export const DELETE_DOCUMENT = `${BASE_URL}/documents/{documentId}`;
}

/**
 * Cashiering
 */
export const GET_ACH_RELATIONSHIPS_URL = `${CC_API_BASE_URL}/cashiering-ach/relationships/{accountId}`;
export const CREATE_ACH_RELATIONSHIPS_URL = `${CC_API_BASE_URL}/cashiering-ach/{accountId}/create`;
export const GET_PLAID_LINK_TOKEN_URL = `${CC_API_BASE_URL}/cashiering-plaid/{accountId}`;
export const UNLINK_BANK_ACCOUNT_URL = `${CC_API_BASE_URL}/cashiering-ach/{accountId}/cancel`;
export const EDIT_NICKNAME_URL = `${CC_API_BASE_URL}/cashiering-ach/{accountId}/update`;
export const DEPOSIT_FUNDS_URL = `${CC_API_BASE_URL}/cashiering-transfer/deposit/{accountId}`;
export const WITHDRAW_FUNDS_URL = `${CC_API_BASE_URL}/cashiering-transfer/withdrawal/{accountId}`;
export const GET_TRANSFERS_URL = `${CC_API_BASE_URL}/cashiering-transfer/{accountId}/transfers`;
export const GET_TRANSACTION_DETAILS_URL = `${CC_API_BASE_URL}/cashiering-transfer/{accountId}/transfer/{transactionId}`;
export const CANCEL_DEPOSIT_URL = `${CC_API_BASE_URL}/cashiering-transfer/{accountId}/transfer/{transactionId}/cancel`;
export const CANCEL_WITHDRAW_URL = `${CC_API_BASE_URL}/cashiering-transfer/{accountId}/transfer/{transactionId}/cancel`;

/**
 * Offers
 */
export const GET_OFFERS_URL = `${CC_API_BASE_URL}/offers`;
export const GET_OFFER_DETAILS_URL = `${CC_API_BASE_URL}/offers/{id}`;
export const GET_OFFER_OPTIONS = `${CC_API_BASE_URL}/offer-options/{type}`;

export const OFFER_WATCHES = `${CC_API_BASE_URL}/offer-watches`;
export const DELETE_OFFER_WATCH = `${OFFER_WATCHES}/{offerWatchId}`;

export namespace InvestigationUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/investigations/{accountId}`;

  export const LIST = `${BASE_URL}`;
  export const APPEAL = `${BASE_URL}/investigation/appeal`;
  export const REJECT = `${BASE_URL}/investigation/reject`;
  export const SUBMIT_DOCUMENT = `${BASE_URL}/investigation/submit/{miscDocumentId}`;
  export const UPLOAD_DOCUMENT = `${BASE_URL}/investigation/{investigationId}/documents`;
  export const DOWNLOAD_DOCUMENT = `${BASE_URL}/investigation/{investigationId}/documents/{documentId}`;
  export const DELETE_DOCUMENT = `${BASE_URL}/investigation/{miscDocumentId}`;

  export const CONTINUE_APPLICATION = `${BASE_URL}/application/continue`;
  export const SUBMIT_APPLICATION_DOCUMENT = `${BASE_URL}/application/submit/{miscDocumentId}`;
  export const UPLOAD_APPLICATION_DOCUMENT = `${BASE_URL}/application/{accountHolderId}/documents`;
  export const DOWNLOAD_APPLICATION_DOCUMENT = `${BASE_URL}/application/{accountHolderId}/documents/{documentId}`;
  export const DELETE_APPLICATION_DOCUMENT = `${BASE_URL}/application/{miscDocumentId}`;
}

/**
 * Configs
 */
export const CONFIGS_URL = `${CC_API_BASE_URL}/configs`;
export namespace PrivateQuoteUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/private-quotes`;

  export const LIST = `${BASE_URL}`;
}

export namespace QuoteUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/quotes`;
  export const LIST = `${BASE_URL}`;
  export const RETRIEVE = `${BASE_URL}/{symbol}`;
  export const GET_CHART = `${BASE_URL}/{symbol}/chart`;
}

export namespace SymbolUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/symbols`;

  export const SEARCH = `${BASE_URL}/search`;
}

export namespace OrderUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/orders`;

  export const CREATE = `${BASE_URL}/accounts/{accountId}`;
  export const LIST = `${BASE_URL}/accounts/{accountId}`;
  export const RETRIEVE = `${BASE_URL}/{id}/accounts/{accountId}`;
  export const CANCEL = `${BASE_URL}/{id}/accounts/{accountId}/cancel`;
}

export namespace PositionUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/positions`;

  export const LIST = `${BASE_URL}/accounts/{accountId}`;
}

/**
 * Offer Orders
 */

export namespace OfferOrderUrlConstant {
  const BASE_URL = `${CC_API_BASE_URL}/offer-orders`;

  export const CREATE = `${BASE_URL}/accounts/{accountId}`;
  export const LIST = `${BASE_URL}/accounts/{accountId}`;
  export const RETRIEVE = `${BASE_URL}/{id}/accounts/{accountId}`;
  export const UPDATE = `${BASE_URL}/{id}/accounts/{accountId}`;
  export const CANCEL = `${BASE_URL}/{id}/accounts/{accountId}/cancel`;
  export const FAIL = `${BASE_URL}/{id}/accounts/{accountId}/fail`;
  export const COMPLETE = `${BASE_URL}/{id}/accounts/{accountId}/complete`;
  export const CREATE_CARD_PAYMENT_INTENT = `${BASE_URL}/card-payment-intents`;
  export const UPDATE_CARD_PAYMENT_INTENT = `${BASE_URL}/card-payment-intents/{id}`;
}

/**
 * Statements
 */
export const GET_TRADE_CONFIRMATION_LIST_URL = `${CC_API_BASE_URL}/statements/{accountId}/trade-confirmations`;
export const DOWNLOAD_TRADE_CONFIRMATION_URL = `${CC_API_BASE_URL}/statements/{accountId}/trade-confirmations/{date}`;
export const GET_MONTHLY_STATEMENT_URL = `${CC_API_BASE_URL}/statements/{accountId}/monthly-statements`;
export const DOWNLOAD_MONTHLY_STATEMENT_URL = `${CC_API_BASE_URL}/statements/{accountId}/monthly-statements/{date}`;
export const GET_TAX_DOCUMENTS_URL = `${CC_API_BASE_URL}/statements/{accountId}/tax-documents`;
export const DOWNLOAD_TAX_DOCUMENT_URL = `${CC_API_BASE_URL}/statements/{accountId}/tax-documents/{date}/forms/{form}`;

export namespace DocumentUriConstant {
  export const MY_IPO_FEE_SCHEDULE = '/static/docs/My_IPO_Fee_Schedule.pdf';
  export const IRA_BENEFICIARY_DESIGNATION_FORM = '/static/docs/IRA_Beneficiary_Designation_Form.pdf';
  export const MY_IPO_QUICK_GUIDE = '/static/docs/MY_IPO_Investment_Guide.pdf';
}
